
















































import { Component, Prop, Vue } from "vue-property-decorator";
import { postArchive } from "../api";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component
export default class UploadForm extends Vue {
  @Prop({ required: true }) projectId!: number;

  description = "";
  file: File | null = null;
  uploadCount = 0;
  hasError = false;
  uploading = false;

  get valid() {
    return this.description !== "" && !!this.file;
  }

  setFile(e?: HTMLInputEvent) {
    if (!e || e.target.files === null) {
      this.file = null;
      return;
    }
    this.file = e.target.files[0];
    if (this.description === "") this.description = this.file.name;
  }

  async uploadFile() {
    if (!this.file || !this.valid) return;
    this.uploading = true;
    this.hasError = false;
    try {
      await postArchive(this.projectId, this.file, this.description);
    } catch (e) {
      this.hasError = true;
      console.error(e);
      return;
    } finally {
      this.uploading = false;
    }
    this.$emit("uploaded");
    this.description = "";
    this.file = null;
    this.uploadCount++;
  }
}
